import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render Business times section on Partners page
 */
const BusinessTimesSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="business-times-section-component">
      <AccordionV2
        testId="business-times"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="The Business Times"
            className="px-0"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 border-none"
        isArrowRight
      >
        <div className="px-6 pb-2 pt-6">
          <p>
            The Business Times (BT), a member of the Singapore Press Holdings
            group, is South-east Asia&apos;s leading financial daily. BT brings
            its readers daily corporate, financial, economic and political news,
            analysis and commentary on print and digital platforms. It provides
            readers with in-depth coverage of Singapore and Asian business and
            economic developments, as well as global trends that impact
            Singapore business. BT&apos;s lifestyle journalists bring busy
            executives the latest in recreation, entertainment, the arts,
            design, food and shopping.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default BusinessTimesSection;
